export const UPDATE_STATS = 'RE UPDATE STATS';
export const SET_OPTIONS = 'RE SET OPTIONS';
export const SELECT_SIZE = 'RE SELECT SIZE';
export const SET_OVER = 'RE SET OVER';
export const SET_CELLS = 'RE SET CELLS';
export const SET_INIT = 'RE SET INIT';
export const UPDATE_TIME = 'RE UPDATE TIME';
export const PAUSE = 'RE PAUSE';
export const REVEAL = 'RE REVEAL';

export const updateStats = stats => ({ type: UPDATE_STATS, stats });
export const setOptions = options => ({ type: SET_OPTIONS, options });
export const selectSize = size => ({ type: SELECT_SIZE, size });
export const setOver = on => ({ type: SET_OVER, over: on });
export const setCells = cells => ({ type: SET_CELLS, cells });
export const setInit = on => ({ type: SET_INIT, init: on });
export const updateTime = msecs => ({ type: UPDATE_TIME, msecs });
export const pause = on => ({ type: PAUSE, on });
export const reveal = on => ({ type: REVEAL, on });
